import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import cx from 'classnames';
import axios from 'axios';
import _ from 'lodash';
import {
  API_NEWCLIENT,
  API_KEY,
  API_CLIENTS_NAME,
  API_GET_PLANS,
  API_GROUPS
} from '../../../utils/constants';
import { useSelector, useDispatch } from 'react-redux';
import { generateContent } from '../../../store/slices/generalState';
import { useHistory } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import BusinessHours from '../AboutSection/BusinessHours/BusinessHours';
import { setSelectedClient } from '../../../store/slices/selectedClient';
import { selectedClientSelector } from '../../../store/slices/selectedClient';
import Links from '../Links';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '../../../components/ui/dialog';

import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Checkbox } from '../../../components/ui/checkbox';
import { Badge } from '../../../components/ui/badge';
import { Switch } from '../../../components/ui/switch';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription
} from '../../../components/ui/card';

import {
  Home,
  Star,
  FileText,
  Image,
  Bell,
  LogOut,
  Menu,
  Facebook,
  Instagram,
  Check,
  X,
  CalendarDays,
  Building2
} from 'lucide-react';

export const daysOrder = {
  Sunday: 1,
  Monday: 2,
  Tuesday: 3,
  Wednesday: 4,
  Thursday: 5,
  Friday: 6,
  Saturday: 7
};

const getHolidaysFromEnv = () => {
  const envHolidays = process.env.REACT_APP_HOLIDAYS_LIST;
  if (!envHolidays) return [];
  try {
    // Si la variable es un JSON, parsea, si es string separado por coma, divide
    if (envHolidays.trim().startsWith('[')) {
      return JSON.parse(envHolidays);
    }
    return envHolidays
      .split(',')
      .map((h) => h.trim())
      .filter(Boolean);
  } catch {
    return [];
  }
};

const UnifiedAboutContent = ({ callbackFromParent, defaultData = {} }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const selectedClient = useSelector((state) => state.selectedClient.id);
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [gettingPlans, setGettingPlans] = useState(false);
  const [industries, setIndustries] = useState([]);
  const [gettingIndustries, setGettingIndustries] = useState(false);

  // Modal states
  const [saveSuccessModalOpen, setSaveSuccessModalOpen] = useState(false);
  const [saveSuccessMessage, setSaveSuccessMessage] = useState('');
  const [saveErrorModalOpen, setSaveErrorModalOpen] = useState(false);

  const holidaysList = getHolidaysFromEnv();

  const initialValues = {
    clientName: '',
    timeZone: '',
    serviceArea: [],
    secondaryServiceArea: [],
    description: '',
    businessHours: {
      monday: '9/18',
      tuesday: '9/18',
      wednesday: '9/18',
      thursday: '9/18',
      friday: '9/18',
      saturday: '9/18',
      sunday: '9/18'
    },
    mergeFields: {
      '~Address': '',
      '~Phone': '',
      '~Website': '',
      '~Email': ''
    },
    industry: '',
    primaryService: [],
    additionalService: [],
    attributes: [],
    promotions: [],
    holidays: [],
    igTags: [],
    fbTags: [],
    negativeKeywords: [],
    galleries: {
      stockPhotos: { enabled: true },
      appLibrary: { enabled: false }
    },
    logoUrl: '',
    brand: {
      primaryColor: '#3B5998',
      secondaryColor: '#8392A5'
    },
    tier: '',
    automaticReviews: true,
    singlePerson: false,
    clientFlags: []
  };

  const userInfo = useSelector((state) => state.auth.userInfo);
  const timeZones = [
    { value: 1, label: 'Eastern Daylight Time - (GMT-4)' },
    { value: 2, label: 'Central Daylight Time - (GMT-5)' },
    { value: 3, label: 'Mountain Daylight Time - (GMT-6)' },
    { value: 4, label: 'Mountain Standard Time - (GMT-7)' },
    { value: 5, label: 'Pacific Daylight Time - (GMT-7)' },
    { value: 6, label: 'Alaska Daylight Time - (GMT-8)' },
    { value: 7, label: 'Hawaii-Aleutian Standard Time - (GMT-10)' }
  ];

  const attributeList = [
    { value: 1, label: 'Curbside Pickup' },
    { value: 2, label: 'Deliver' },
    { value: 3, label: 'Dine-in' },
    { value: 4, label: 'Drive through' },
    { value: 5, label: 'No-contact delivery' },
    { value: 6, label: 'Outdoor seating' },
    { value: 7, label: 'Takeout' },
    { value: 8, label: 'Assistive hearing loop' },
    { value: 9, label: 'Beach wheelchairs' },
    { value: 10, label: 'Mobility scooter rental' },
    { value: 11, label: 'Passenger loading area' },
    { value: 12, label: 'Wheelchair-accessible elevator' },
    { value: 13, label: 'Wheelchair-accessible entrance' },
    { value: 14, label: 'Wheelchair-accessible parking' },
    { value: 15, label: 'Wheelchair-accessible restroom' },
    { value: 16, label: 'Wheelchair-accessible seating' },
    { value: 17, label: 'Adults only' },
    { value: 18, label: 'Family-friendly' },
    { value: 19, label: 'Kid-friendly' },
    { value: 20, label: 'LGBTQ+ friendly' },
    { value: 21, label: 'Transgender safespace' },
    { value: 22, label: 'Accepting new patients' },
    { value: 23, label: 'Accepts reservations' },
    { value: 24, label: 'Appointment required' },
    { value: 25, label: 'Membership required' },
    { value: 26, label: 'Online events calendar' },
    { value: 27, label: 'Reservations recommended' },
    { value: 28, label: 'Reservations required' },
    { value: 29, label: 'Beach access' },
    { value: 30, label: 'Bicycles for rent' },
    { value: 31, label: 'Boats for rent' },
    { value: 32, label: 'Game room' },
    { value: 33, label: 'Horseback riding' },
    { value: 34, label: 'Jogging track' },
    { value: 35, label: 'Nightclub' },
    { value: 36, label: 'Scuba diving' },
    { value: 37, label: 'Snorkeling' },
    { value: 38, label: 'Tennis' },
    { value: 39, label: 'Water skiing' },
    { value: 40, label: 'Identifies as black owned' },
    { value: 41, label: 'Identifies as veteran-led' },
    { value: 42, label: 'Identifies as women-led' },
    { value: 43, label: 'Cash Only' },
    { value: 44, label: 'Checks' },
    { value: 45, label: 'Debit Cards' },
    { value: 46, label: 'NFC Mobile Payments' },
    { value: 47, label: 'American Express' },
    { value: 48, label: 'Master Card' },
    { value: 49, label: 'Visa' },
    { value: 50, label: 'Discover' },
    { value: 51, label: 'Diners club' }
  ];

  const customMultiSelectorStyle = {
    dropdownIndicator: () => ({ display: 'none' }),
    indicatorSeparator: () => ({ display: 'none' }),
    control: (provided) => ({
      ...provided,
      width: '100%',
      minHeight: '36px',
      height: 'auto',
      border: '1px solid #e2e8f0',
      borderRadius: '4px',
      boxShadow: 'none',
      '&:hover': { borderColor: '#3B5998' }
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: 200
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#3B5998',
      color: 'white',
      borderRadius: '6px',
      margin: '2px'
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: 'white'
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: 'white',
      '&:hover': {
        backgroundColor: '#D9D9D9',
        color: 'black'
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      minHeight: 'auto',
      maxHeight: 'none',
      overflowY: 'visible',
      overflowX: 'hidden'
    })
  };

  const validationSchema = yup.object().shape({
    clientName: yup.string().required('Client name is required'),
    timeZone: yup.string().required('Time zone is required'),
    serviceArea: yup
      .array()
      .min(1, 'Primary Service Area is required')
      .of(
        yup
          .string()
          .matches(
            /^[a-zA-Z0-9áéíóúÁÉÍÓÚ][a-zA-Z0-9áéíóúÁÉÍÓÚ\s',.~-]*$/,
            'A service area has an invalid format'
          )
      ),
    secondaryServiceArea: yup
      .array()
      .of(
        yup
          .string()
          .matches(
            /^[a-zA-Z0-9áéíóúÁÉÍÓÚ][a-zA-Z0-9áéíóúÁÉÍÓÚ\s',.~-]*$/,
            'A secondary service area has an invalid format'
          )
      ),
    description: yup.string(),
    businessHours: yup.object().shape({
      monday: yup
        .string()
        .matches(
          /^((?:2[0-4]|1[0-9]|[0-9])\/(?:2[0-4]|1[0-9]|[0-9])|\/)$/,
          'Invalid format hour should be a number between 0-24'
        ),
      tuesday: yup
        .string()
        .matches(
          /^((?:2[0-4]|1[0-9]|[0-9])\/(?:2[0-4]|1[0-9]|[0-9])|\/)$/,
          'Invalid format hour should be a number between 0-24'
        ),
      wednesday: yup
        .string()
        .matches(
          /^((?:2[0-4]|1[0-9]|[0-9])\/(?:2[0-4]|1[0-9]|[0-9])|\/)$/,
          'Invalid format hour should be a number between 0-24'
        ),
      thursday: yup
        .string()
        .matches(
          /^((?:2[0-4]|1[0-9]|[0-9])\/(?:2[0-4]|1[0-9]|[0-9])|\/)$/,
          'Invalid format hour should be a number between 0-24'
        ),
      friday: yup
        .string()
        .matches(
          /^((?:2[0-4]|1[0-9]|[0-9])\/(?:2[0-4]|1[0-9]|[0-9])|\/)$/,
          'Invalid format hour should be a number between 0-24'
        ),
      saturday: yup
        .string()
        .matches(
          /^((?:2[0-4]|1[0-9]|[0-9])\/(?:2[0-4]|1[0-9]|[0-9])|\/)$/,
          'Invalid format hour should be a number between 0-24'
        ),
      sunday: yup
        .string()
        .matches(
          /^((?:2[0-4]|1[0-9]|[0-9])\/(?:2[0-4]|1[0-9]|[0-9])|\/)$/,
          'Invalid format hour should be a number between 0-24'
        )
    }),
    mergeFields: yup.object().shape({
      '~Address': yup.string(),
      '~Phone': yup.string().required('Phone is required'),
      '~Website': yup.string(),
      '~Email': yup.string()
    }),
    industry: yup.string().required('Industry is required'),
    primaryService: yup
      .array()
      .of(
        yup
          .string()
          .matches(
            /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s'",@~#%$&*!_\-=:./?|\\()[\]{}<>]+$/,
            'A primary service has an invalid format'
          )
      ),
    additionalService: yup
      .array()
      .of(
        yup
          .string()
          .matches(
            /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s'",@~#%$&*!_\-=:./?|\\()[\]{}<>]+$/,
            'An additional service has an invalid format'
          )
      ),
    attributes: yup.array().of(yup.string()),
    promotions: yup
      .array()
      .of(
        yup
          .string()
          .matches(
            /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s'",@~#%$&*!_\-=:./?|\\()[\]{}<>]+$/,
            'A promotion has an invalid format'
          )
      ),
    holidays: yup
      .array()
      .of(
        yup
          .string()
          .matches(
            /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s'",@~#%$&*!_\-=:./?|\\()[\]{}<>]+$/,
            'Invalid format'
          )
      ),
    igTags: yup
      .array()
      .of(
        yup
          .string()
          .matches(
            /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s'",@~#%$&*!_\-=:./?|\\()[\]{}<>]+$/,
            'A tag has an invalid format'
          )
      ),
    fbTags: yup
      .array()
      .of(
        yup
          .string()
          .matches(
            /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s'",@~#%$&*!_\-=:./?|\\()[\]{}<>]+$/,
            'A tag has an invalid format'
          )
      ),
    negativeKeywords: yup.array().of(yup.string()),
    galleries: yup.object().shape({
      stockPhotos: yup.object().shape({ enabled: yup.boolean() }),
      appLibrary: yup.object().shape({ enabled: yup.boolean() })
    }),
    logoUrl: yup.string(),
    brand: yup.object().shape({
      primaryColor: yup.string(),
      secondaryColor: yup.string()
    }),
    tier: yup.string(),
    automaticReviews: yup.boolean(),
    singlePerson: yup.boolean(),
    clientFlags: yup.array().of(yup.string())
  });

  const editing = Object.keys(defaultData).length > 0;

  const SingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props} className="selected-option">
      {children}
      <div className="selected-logo">
        <Connected />
      </div>
    </components.SingleValue>
  );

  const Option = (props) => (
    <components.Option {...props}>
      <div className="country-option">
        {props.data.label}
        <Disconnected />
      </div>
    </components.Option>
  );

  const Connected = () => (
    <img src="../assets/img/Connected.png" alt="connected" />
  );

  const Disconnected = () => (
    <img src="../assets/img/Disconnected.png" alt="disconnected" />
  );

  // Reset industries when selected client changes
  useEffect(() => {
    setIndustries([]);
  }, [selectedClient]);

  // Fetch plans and content strategies
  useEffect(() => {
    const getPlans = async () => {
      setGettingPlans(true);
      try {
        const response = await axios.get(`${API_GET_PLANS}`);
        const plans = response.data;
        const order = ['Starter Plan', 'Plus Plan', 'Pro Plan', 'Elite Plan'];
        const formattedPlans = plans.map((plan) => ({
          ...plan,
          value: plan.PK,
          label: plan.SK
        }));
        const sortedPlans = formattedPlans.sort(
          (a, b) => order.indexOf(a.label) - order.indexOf(b.label)
        );
        setPlans(sortedPlans);
      } catch (e) {
        console.error(e);
      } finally {
        setGettingPlans(false);
      }
    };

    const getIndustries = async () => {
      setGettingIndustries(true);
      try {
        const response = await axios.get(API_GROUPS, {
          headers: { Authorization: `bearer ${userInfo.accessToken}` }
        });
        const groupsData = response.data.groups;
        const newIndustries = groupsData?.map((option) => ({
          value: option.id,
          label: option.groupName
        }));
        setIndustries((prev) =>
          _.isEqual(prev, newIndustries) ? prev : newIndustries
        );
      } catch (e) {
        console.error('API_GROUPS Error:', e);
      } finally {
        setGettingIndustries(false);
      }
    };

    if (plans.length === 0 && !gettingPlans) {
      getPlans();
    }
    if (industries.length === 0 && !gettingIndustries) {
      getIndustries();
    }
  }, []);

  const handlePut = async (data = {}) => {
    setLoading(true);
    let newClientName = data.clientName.replace(/\s+/g, ' ');
    newClientName = newClientName.replace(/^\s+|\s+$/g, '');
    newClientName = newClientName.replace(/'/g, "'");

    const clientData = {
      ...data,
      id: defaultData?.id,
      clientName: newClientName
    };

    try {
      const response = await axios({
        method: 'post',
        url: API_NEWCLIENT,
        data: clientData
      });

      if (response.status === 200) {
        const successMessage = `The client was ${
          clientData.id ? 'updated' : 'created'
        } successfully.`;
        setSaveSuccessMessage(successMessage);
        setSaveSuccessModalOpen(true);

        callbackFromParent(clientData);

        if (clientData?.id) {
          const clData = await axios.get(
            `${API_CLIENTS_NAME}${clientData.clientName}`,
            {
              headers: {
                'X-API-KEY': API_KEY,
                Authorization: `bearer ${userInfo.accessToken}`
              }
            }
          );
          let newUrl = clData?.data?.clientName
            .replace(/\s+/g, '%20')
            .replace(/\//g, '%2F')
            .replace(/'/g, '%1D')
            .replace(/'/g, '%1E');
          history.push(`/client/${newUrl}`);
          if (clData.data) {
            dispatch(setSelectedClient(clData.data));
          }
        } else {
          const clData = await axios.get(
            `${API_CLIENTS_NAME}${clientData.clientName}`,
            {
              headers: {
                'X-API-KEY': API_KEY,
                Authorization: `bearer ${userInfo.accessToken}`
              }
            }
          );
          history.push('/calendar');
          if (clData.data) {
            dispatch(setSelectedClient(clData.data));
            dispatch(generateContent());
          }
        }
      }
    } catch (error) {
      setSaveErrorModalOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Formik
        onSubmit={handlePut}
        enableReinitialize
        validateOnBlur={true}
        initialValues={
          editing
            ? {
                ...defaultData,
                ...(!defaultData.businessHours?.monday
                  ? { businessHours: initialValues.businessHours }
                  : {}),
                ...(!defaultData?.brand?.primaryColor
                  ? { brand: initialValues.brand }
                  : {})
              }
            : initialValues
        }
        validationSchema={validationSchema}>
        {(props) => {
          const {
            handleSubmit,
            setFieldValue,
            values,
            handleChange,
            handleBlur,
            errors,
            touched
          } = props;

          return (
            <>
              {/* Header */}

              <header className="sticky top-0 z-10 bg-card shadow-sm border-b ">
                <div className="px-6 py-4 flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div>
                      <h1 className="text-xl font-semibold m-0">My Business</h1>
                      <p className="text-sm text-muted-foreground m-0">
                        Manage your information and social networks
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <Button
                      type="button"
                      disabled={loading}
                      onClick={handleSubmit}
                      className="border-0">
                      {loading ? (
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                        />
                      ) : (
                        'Save Data'
                      )}
                    </Button>
                  </div>
                </div>
              </header>

              {/* Content Area */}
              <Form autoComplete="off" className="needs-validation" noValidate>
                <main className="p-6 space-y-6">
                  <Links selectedClient={defaultData} userInfo={userInfo} />

                  <Card className="rounded-lg border bg-card text-card-foreground shadow-sm">
                    <CardHeader>
                      <CardTitle className="text-lg">
                        Business Information
                      </CardTitle>
                      <CardDescription>
                        Basic details about your company
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                          <Label htmlFor="clientName">Business Name *</Label>
                          <Input
                            id="clientName"
                            type="text"
                            required
                            placeholder="Enter business name"
                            value={values?.clientName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className={`${
                              touched?.clientName && errors?.clientName
                                ? 'is-invalid'
                                : ''
                            }`}
                          />
                          {touched?.clientName && errors?.clientName && (
                            <div>{errors?.clientName}</div>
                          )}
                        </div>

                        <div className="space-y-2">
                          <Label htmlFor="clientName">Phone *</Label>
                          <Input
                            id="mergeFields.~Phone"
                            type="text"
                            onChange={handleChange}
                            value={values?.mergeFields['~Phone'] || ''}
                            className={`${
                              touched?.mergeFields?.['~Phone'] &&
                              errors?.mergeFields?.['~Phone']
                                ? 'is-invalid'
                                : ''
                            }`}
                            placeholder="Enter Phone"
                            onBlur={handleBlur}
                          />
                          {touched?.mergeFields?.['~Phone'] &&
                            errors?.mergeFields?.['~Phone'] && (
                              <div className="invalid-feedback">
                                {errors?.mergeFields?.['~Phone']}
                              </div>
                            )}
                        </div>

                        <div className="space-y-2">
                          <Label htmlFor="clientName">Email</Label>
                          <Input
                            id="mergeFields.~Email"
                            type="text"
                            onChange={handleChange}
                            value={values?.mergeFields['~Email'] || ''}
                            placeholder="Enter Email"
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="space-y-2">
                          <Label htmlFor="clientName">Website</Label>
                          <Input
                            id="mergeFields.~Website"
                            type="text"
                            onChange={handleChange}
                            value={values?.mergeFields['~Website'] || ''}
                            className={`${
                              touched?.mergeFields?.['~Website'] &&
                              errors?.mergeFields?.['~Website']
                                ? 'is-invalid'
                                : ''
                            }`}
                            placeholder="Enter Website"
                            onBlur={handleBlur}
                          />
                          {touched?.mergeFields?.['~Website'] &&
                            errors?.mergeFields?.['~Website'] && (
                              <div className="invalid-feedback">
                                {errors?.mergeFields?.['~Website']}
                              </div>
                            )}
                        </div>

                        <div className="space-y-2">
                          <Label htmlFor="clientName">Address</Label>
                          <Input
                            id="mergeFields.~Address"
                            type="text"
                            onChange={handleChange}
                            value={values?.mergeFields['~Address'] || ''}
                            placeholder="Enter ~Address"
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="space-y-2">
                          <Label htmlFor="clientName">
                            Primary Service Area *
                          </Label>
                          <CreatableSelect
                            id="serviceArea"
                            name="serviceArea"
                            isMulti
                            isClearable={false}
                            value={values?.serviceArea?.map((servA, index) => ({
                              value: index,
                              label: servA
                            }))}
                            noOptionsMessage={() => 'Type a service area'}
                            onChange={(selectedOption) => {
                              setFieldValue(
                                'serviceArea',
                                selectedOption
                                  ? selectedOption.map((servA) => servA.label)
                                  : []
                              );
                            }}
                            options={[]}
                            placeholder="Type a service area"
                            onBlur={() =>
                              setFieldValue('serviceArea', values?.serviceArea)
                            }
                            className={`${
                              touched?.serviceArea && errors?.serviceArea
                                ? 'is-invalid'
                                : ''
                            }`}
                            styles={{
                              ...customMultiSelectorStyle,
                              control: (provided, state) => ({
                                ...customMultiSelectorStyle.control(provided),
                                borderColor:
                                  touched?.serviceArea && errors?.serviceArea
                                    ? '#dc3545'
                                    : '#e2e8f0',
                                boxShadow:
                                  touched?.serviceArea && errors?.serviceArea
                                    ? '0 0 0 3px rgba(220, 53, 69, 0.1)'
                                    : 'none',
                                '&:hover': {
                                  borderColor:
                                    touched?.serviceArea && errors?.serviceArea
                                      ? '#dc3545'
                                      : '#3B5998'
                                }
                              })
                            }}
                          />
                          {touched?.serviceArea && errors?.serviceArea && (
                            <div className="invalid-feedback">
                              {errors?.serviceArea}
                            </div>
                          )}
                        </div>
                        <div className="space-y-2 md:col-span-2">
                          <Label htmlFor="clientName">
                            Secondary Service Area
                          </Label>
                          <CreatableSelect
                            id="secondaryServiceArea"
                            name="secondaryServiceArea"
                            isMulti
                            isClearable={false}
                            value={values?.secondaryServiceArea?.map(
                              (servA, index) => ({
                                value: index,
                                label: servA
                              })
                            )}
                            noOptionsMessage={() =>
                              'Type a secondary service area'
                            }
                            onChange={(selectedOption) => {
                              setFieldValue(
                                'secondaryServiceArea',
                                selectedOption
                                  ? selectedOption.map((servA) => servA.label)
                                  : []
                              );
                            }}
                            options={[]}
                            placeholder="Type a secondary service area"
                            onBlur={() =>
                              setFieldValue(
                                'secondaryServiceArea',
                                values?.secondaryServiceArea
                              )
                            }
                            styles={customMultiSelectorStyle}
                          />
                        </div>
                        <div className="space-y-2 md:col-span-2">
                          <Label htmlFor="clientName">Description</Label>
                          <Textarea
                            id="description"
                            onChange={handleChange}
                            value={values?.description}
                            onBlur={handleBlur}
                            rows={3}
                            placeholder="Describe your business..."
                          />
                        </div>
                        <div className="space-y-2 md:col-span-2">
                          <BusinessHours
                            values={values}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="rounded-lg border bg-card text-card-foreground shadow-sm">
                    <CardHeader>
                      <CardTitle className="text-lg">Preferences</CardTitle>
                      <CardDescription>
                        Customize how we manage your content
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                          <Label htmlFor="clientName">Time Zone *</Label>
                          <Select
                            required
                            name="timeZone"
                            options={timeZones}
                            value={timeZones.find(
                              (option) => option.label === values?.timeZone
                            )}
                            onChange={(selectedOption) =>
                              setFieldValue('timeZone', selectedOption.label)
                            }
                            onBlur={() =>
                              setFieldValue('timeZone', values?.timeZone)
                            }
                            className={`${
                              touched?.timeZone && errors?.timeZone
                                ? 'is-invalid'
                                : ''
                            }`}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                borderColor:
                                  touched?.timeZone && errors?.timeZone
                                    ? '#dc3545'
                                    : '#e2e8f0',
                                '&:hover': { borderColor: '#3B5998' }
                              })
                            }}
                          />
                          {errors?.timeZone && touched?.timeZone && (
                            <div className="invalid-feedback">
                              {errors?.timeZone}
                            </div>
                          )}
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="clientName">Industry *</Label>
                          <Select
                            id="industry"
                            options={industries}
                            value={industries.find(
                              (option) => option?.value === values?.industry
                            )}
                            onChange={(selectedOption) =>
                              setFieldValue('industry', selectedOption?.value)
                            }
                            onBlur={() =>
                              setFieldValue('industry', values?.industry)
                            }
                            placeholder="Select industry"
                            isLoading={gettingIndustries}
                            className={`${
                              touched?.industry && errors?.industry
                                ? 'is-invalid'
                                : ''
                            }`}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                borderColor:
                                  touched?.industry && errors?.industry
                                    ? '#dc3545'
                                    : '#e2e8f0',
                                '&:hover': { borderColor: '#3b5998' }
                              })
                            }}
                          />
                          {errors?.industry && touched?.industry && (
                            <div className="invalid-feedback">
                              {errors?.industry}
                            </div>
                          )}
                        </div>
                        <div className="space-y-2 md:col-span-2">
                          <div className="flex items-center justify-between rounded-lg border border-gray-200 p-4 hover:bg-gray-50 transition-colors">
                            <div className="space-y-0.5">
                              <Label
                                htmlFor="automaticReviews"
                                className="text-base font-medium cursor-pointer">
                                Automatic Reviews
                              </Label>
                              <p className="text-sm text-muted-foreground m-0">
                                Automatically respond to customer reviews
                              </p>
                            </div>
                            <Switch
                              id="automaticReviews"
                              checked={values.automaticReviews}
                              onCheckedChange={(checked) => {
                                setFieldValue('automaticReviews', checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className="space-y-2 md:col-span-2">
                          <div className="flex items-center justify-between rounded-lg border border-gray-200 p-4 hover:bg-gray-50 transition-colors">
                            <div className="space-y-0.5">
                              <Label
                                htmlFor="singlePerson"
                                className="text-base font-medium cursor-pointer">
                                Single Person Business
                              </Label>
                              <p className="text-sm text-muted-foreground m-0">
                                This business is operated by a single person
                              </p>
                            </div>
                            <Switch
                              id="singlePerson"
                              checked={values.singlePerson}
                              onCheckedChange={(checked) => {
                                setFieldValue('singlePerson', checked);
                              }}
                            />
                          </div>
                        </div>
                        <div className="space-y-2 md:col-span-2">
                          <div className="flex items-center justify-between rounded-lg border border-gray-200 p-4 hover:bg-gray-50 transition-colors">
                            <div className="space-y-0.5">
                              <Label
                                htmlFor="clientFlags.NO_FB"
                                className="text-base font-medium cursor-pointer">
                                No Facebook
                              </Label>
                              <p className="text-sm text-muted-foreground m-0">
                                Disable Facebook posting for this client
                              </p>
                            </div>
                            <Switch
                              id="clientFlags.NO_FB"
                              checked={
                                values?.clientFlags?.includes('NO_FB') || false
                              }
                              onCheckedChange={(checked) => {
                                const currentFlags = values?.clientFlags || [];
                                if (checked) {
                                  setFieldValue('clientFlags', [
                                    ...currentFlags,
                                    'NO_FB'
                                  ]);
                                } else {
                                  setFieldValue(
                                    'clientFlags',
                                    currentFlags.filter(
                                      (flag) => flag !== 'NO_FB'
                                    )
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>

                        <div className="space-y-2 md:col-span-2">
                          <div className="flex items-center justify-between rounded-lg border border-gray-200 p-4 hover:bg-gray-50 transition-colors">
                            <div className="space-y-0.5">
                              <Label
                                htmlFor="clientFlags.NO_AI"
                                className="text-base font-medium cursor-pointer">
                                No AI Images
                              </Label>
                              <p className="text-sm text-muted-foreground m-0">
                                Disable AI-generated images for this account
                              </p>
                            </div>
                            <Switch
                              id="clientFlags.NO_AI"
                              checked={
                                values?.clientFlags?.includes('NO_AI') || false
                              }
                              onCheckedChange={(checked) => {
                                const currentFlags = values?.clientFlags || [];
                                if (checked) {
                                  setFieldValue('clientFlags', [
                                    ...currentFlags,
                                    'NO_AI'
                                  ]);
                                } else {
                                  setFieldValue(
                                    'clientFlags',
                                    currentFlags.filter(
                                      (flag) => flag !== 'NO_AI'
                                    )
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>

                        <div className="space-y-2 md:col-span-2">
                          <div className="flex items-center justify-between rounded-lg border border-gray-200 p-4 hover:bg-gray-50 transition-colors">
                            <div className="space-y-0.5">
                              <Label
                                htmlFor="clientFlags.NO_GMB"
                                className="text-base font-medium cursor-pointer">
                                No Google My Business
                              </Label>
                              <p className="text-sm text-muted-foreground m-0">
                                Disable Google My Business posting
                              </p>
                            </div>
                            <Switch
                              id="clientFlags.NO_GMB"
                              checked={
                                values?.clientFlags?.includes('NO_GMB') || false
                              }
                              onCheckedChange={(checked) => {
                                const currentFlags = values?.clientFlags || [];
                                if (checked) {
                                  setFieldValue('clientFlags', [
                                    ...currentFlags,
                                    'NO_GMB'
                                  ]);
                                } else {
                                  setFieldValue(
                                    'clientFlags',
                                    currentFlags.filter(
                                      (flag) => flag !== 'NO_GMB'
                                    )
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>

                        <div className="space-y-2 md:col-span-2">
                          <div className="flex items-center justify-between rounded-lg border border-gray-200 p-4 hover:bg-gray-50 transition-colors">
                            <div className="space-y-0.5">
                              <Label
                                htmlFor="clientFlags.NO_REVIEWS"
                                className="text-base font-medium cursor-pointer">
                                No Reviews
                              </Label>
                              <p className="text-sm text-muted-foreground m-0">
                                Disable review management features
                              </p>
                            </div>
                            <Switch
                              id="clientFlags.NO_REVIEWS"
                              checked={
                                values?.clientFlags?.includes('NO_REVIEWS') ||
                                false
                              }
                              onCheckedChange={(checked) => {
                                const currentFlags = values?.clientFlags || [];
                                if (checked) {
                                  setFieldValue('clientFlags', [
                                    ...currentFlags,
                                    'NO_REVIEWS'
                                  ]);
                                } else {
                                  setFieldValue(
                                    'clientFlags',
                                    currentFlags.filter(
                                      (flag) => flag !== 'NO_REVIEWS'
                                    )
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>

                        <div className="space-y-2 md:col-span-2">
                          <div className="flex items-center justify-between rounded-lg border border-gray-200 p-4 hover:bg-gray-50 transition-colors">
                            <div className="space-y-0.5">
                              <Label
                                htmlFor="clientFlags.NO_IG"
                                className="text-base font-medium cursor-pointer">
                                No Instagram
                              </Label>
                              <p className="text-sm text-muted-foreground m-0">
                                Disable Instagram posting for this client
                              </p>
                            </div>
                            <Switch
                              id="clientFlags.NO_IG"
                              checked={
                                values?.clientFlags?.includes('NO_IG') || false
                              }
                              onCheckedChange={(checked) => {
                                const currentFlags = values?.clientFlags || [];
                                if (checked) {
                                  setFieldValue('clientFlags', [
                                    ...currentFlags,
                                    'NO_IG'
                                  ]);
                                } else {
                                  setFieldValue(
                                    'clientFlags',
                                    currentFlags.filter(
                                      (flag) => flag !== 'NO_IG'
                                    )
                                  );
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="rounded-lg border bg-card text-card-foreground shadow-sm">
                    <CardHeader>
                      <CardTitle className="text-lg">Services</CardTitle>
                      <CardDescription>
                        Describe the services your business offers
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-2 md:col-span-2">
                          <Label htmlFor="clientName">Primary Services</Label>
                          <CreatableSelect
                            id="primaryService"
                            name="primaryService"
                            isMulti
                            isClearable={false}
                            value={values?.primaryService?.map(
                              (servA, index) => ({
                                value: index,
                                label: servA
                              })
                            )}
                            noOptionsMessage={() => 'Type a primary service'}
                            onChange={(selectedOption) => {
                              setFieldValue(
                                'primaryService',
                                selectedOption
                                  ? selectedOption.map((servA) => servA.label)
                                  : []
                              );
                            }}
                            options={[]}
                            placeholder="Type a primary service"
                            styles={customMultiSelectorStyle}
                          />
                        </div>
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="rounded-lg border bg-card text-card-foreground shadow-sm">
                    <CardHeader>
                      <CardTitle className="text-lg">
                        Content Strategy
                      </CardTitle>
                      <CardDescription>
                        Configure your content preferences and tags
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                          <Label htmlFor="clientName">Attributes</Label>
                          <Select
                            id="attributes"
                            isMulti
                            options={attributeList}
                            value={attributeList.filter((attr) =>
                              values?.attributes?.includes(attr.label)
                            )}
                            onChange={(selectedOption) => {
                              setFieldValue(
                                'attributes',
                                selectedOption
                                  ? selectedOption.map((attr) => attr.label)
                                  : []
                              );
                            }}
                            placeholder="Select attributes"
                            styles={customMultiSelectorStyle}
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="clientName">Instagram Tags</Label>
                          <CreatableSelect
                            id="igTags"
                            name="igTags"
                            isMulti
                            isClearable={false}
                            value={values?.igTags?.map((tag, index) => ({
                              value: index,
                              label: tag
                            }))}
                            noOptionsMessage={() => 'Type an Instagram tag'}
                            onChange={(selectedOption) => {
                              setFieldValue(
                                'igTags',
                                selectedOption
                                  ? selectedOption.map((tag) => tag.label)
                                  : []
                              );
                            }}
                            options={[]}
                            placeholder="Type an Instagram tag"
                            styles={customMultiSelectorStyle}
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="clientName">Promotions</Label>
                          <CreatableSelect
                            id="promotions"
                            name="promotions"
                            isMulti
                            isClearable={false}
                            value={values?.promotions?.map((promo, index) => ({
                              value: index,
                              label: promo
                            }))}
                            noOptionsMessage={() => 'Type a promotion'}
                            onChange={(selectedOption) => {
                              setFieldValue(
                                'promotions',
                                selectedOption
                                  ? selectedOption.map((promo) => promo.label)
                                  : []
                              );
                            }}
                            options={[]}
                            placeholder="Type a promotion"
                            styles={customMultiSelectorStyle}
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="clientName">Facebook Tags</Label>
                          <CreatableSelect
                            id="fbTags"
                            name="fbTags"
                            isMulti
                            isClearable={false}
                            value={values?.fbTags?.map((tag, index) => ({
                              value: index,
                              label: tag
                            }))}
                            noOptionsMessage={() => 'Type a Facebook tag'}
                            onChange={(selectedOption) => {
                              setFieldValue(
                                'fbTags',
                                selectedOption
                                  ? selectedOption.map((tag) => tag.label)
                                  : []
                              );
                            }}
                            options={[]}
                            placeholder="Type a Facebook tag"
                            styles={customMultiSelectorStyle}
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="clientName">Negative Keywords</Label>
                          <CreatableSelect
                            id="negativeKeywords"
                            name="negativeKeywords"
                            isMulti
                            isClearable={false}
                            value={values?.negativeKeywords?.map(
                              (keyword, index) => ({
                                value: index,
                                label: keyword
                              })
                            )}
                            noOptionsMessage={() => 'Type a negative keyword'}
                            onChange={(selectedOption) => {
                              setFieldValue(
                                'negativeKeywords',
                                selectedOption
                                  ? selectedOption.map(
                                      (keyword) => keyword.label
                                    )
                                  : []
                              );
                            }}
                            options={[]}
                            placeholder="Type a negative keyword"
                            styles={customMultiSelectorStyle}
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="clientName">
                            Additional Services
                          </Label>
                          <CreatableSelect
                            id="additionalService"
                            name="additionalService"
                            isMulti
                            isClearable={false}
                            value={values?.additionalService?.map(
                              (servA, index) => ({
                                value: index,
                                label: servA
                              })
                            )}
                            noOptionsMessage={() =>
                              'Type an additional service'
                            }
                            onChange={(selectedOption) => {
                              setFieldValue(
                                'additionalService',
                                selectedOption
                                  ? selectedOption.map((servA) => servA.label)
                                  : []
                              );
                            }}
                            options={[]}
                            placeholder="Type an additional service"
                            styles={customMultiSelectorStyle}
                          />
                        </div>
                        <div className="space-y-2">
                          <Label htmlFor="clientName">Holidays</Label>
                          <div
                            className="client-flags-container"
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '1fr 1fr',
                              gap: '8px 16px'
                            }}>
                            {holidaysList.map((holiday) => (
                              <div key={holiday} className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`holidays.${holiday}`}
                                  checked={
                                    values?.holidays?.includes(holiday) || false
                                  }
                                  onChange={(e) => {
                                    const currentHolidays =
                                      values?.holidays || [];
                                    if (e.target.checked) {
                                      setFieldValue('holidays', [
                                        ...currentHolidays,
                                        holiday
                                      ]);
                                    } else {
                                      setFieldValue(
                                        'holidays',
                                        currentHolidays.filter(
                                          (flag) => flag !== holiday
                                        )
                                      );
                                    }
                                  }}
                                />
                                <Label
                                  className="form-check-label"
                                  htmlFor={`holidays.${holiday}`}>
                                  {holiday}
                                </Label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </main>
              </Form>
              {/* Footer */}
            </>
          );
        }}
      </Formik>

      {/* Dialog Modals */}
      <Dialog
        open={saveSuccessModalOpen}
        onOpenChange={setSaveSuccessModalOpen}>
        <DialogContent className="sm:max-w-md text-center py-10">
          <DialogHeader className="items-center">
            <DialogTitle className="text-2xl font-bold text-foreground">
              Success!
            </DialogTitle>
            <DialogDescription className="text-base text-muted-foreground mt-2">
              {saveSuccessMessage}
            </DialogDescription>
          </DialogHeader>
          <div className="flex justify-center mt-4">
            <Button
              className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
              onClick={() => setSaveSuccessModalOpen(false)}>
              OK
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={saveErrorModalOpen} onOpenChange={setSaveErrorModalOpen}>
        <DialogContent className="sm:max-w-md text-center py-10">
          <DialogHeader className="items-center">
            <DialogTitle className="text-2xl font-bold text-foreground">
              Error!
            </DialogTitle>
            <DialogDescription className="text-base text-muted-foreground mt-2">
              We can't edit the client due to an error.
            </DialogDescription>
          </DialogHeader>
          <div className="flex justify-center mt-4">
            <Button
              className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
              onClick={() => setSaveErrorModalOpen(false)}>
              OK
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UnifiedAboutContent;
